/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Hidden(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <line
        x1="3.96967"
        y1="19.7197"
        x2="19.7197"
        y2="3.96967"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M17.0611 7.56758C15.7025 6.67941 14.0099 6 12.0113 6C6.3345 6 3 11.6632 3 11.6632C3 11.6632 4.85397 14.903 7.8792 16.7495L9.68247 14.9462C8.81065 14.259 8.25 13.1937 8.25 12C8.25 9.93225 9.93225 8.25 12 8.25C13.1937 8.25 14.259 8.81065 14.9462 9.68247L17.0611 7.56758ZM11.1073 15.6427C11.3935 15.7128 11.6925 15.75 12 15.75C14.0677 15.75 15.75 14.0677 15.75 12C15.75 11.6925 15.7128 11.3935 15.6427 11.1073L18.2722 8.47775C20.0555 10.0011 21 11.6632 21 11.6632C21 11.6632 17.811 18 12.0113 18C11.0438 18 10.1332 17.7955 9.29008 17.4599L11.1073 15.6427Z"
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
}

Hidden.defaultProps = {
  color: "currentColor",
  size: 24,
};

Hidden.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
